/**
 * Converts a currency amount to its minor units (smallest denomination).
 * Uses integer arithmetic to avoid floating-point precision errors.
 *
 * @param amount - Amount in major units (e.g., 10.50 dollars)
 * @param decimals - Number of decimal places in the currency (default: 2)
 *                   - 2 for USD, EUR, GBP (cents/pence)
 *                   - 0 for JPY, KRW (no minor units)
 *                   - 3 for KWD, BHD, OMR (fils)
 * @returns Amount in minor units as integer
 *
 * @example
 * toMinorUnits(10.50, 2)  // 1050 (USD cents)
 * toMinorUnits(10.50, 0)  // 11 (JPY - rounds to nearest yen)
 * toMinorUnits(10.500, 3) // 10500 (KWD fils)
 */
export const toMinorUnits = (amount: number, decimals: number = 2): number => {
  const multiplier = Math.pow(10, decimals);

  return Math.round(amount * multiplier);
};
